module.exports = __webpack_public_path__ + "static/bg-dc2cec289e08ec2d071752b8c611cfcd.jpg";